import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

const payloadSchema = z.object({
  submission_id: z.string().max(120),
  full_name: z.string().trim().min(2).max(80),
  first_name: z.string().trim().max(80).optional().or(z.literal("")),
  last_name: z.string().trim().max(80).optional().or(z.literal("")),
  email: z.string().trim().email().max(160),
  phone: z.string().trim().min(7).max(20),
  postal_code: z.string().trim().max(10),
  what_area_do_you_want_to_coat: z.string().min(1).max(80),
  what_is_the_approximate_size_of_the_area: z.string().min(1).max(80),
  timeline_for_project: z.string().min(1).max(80),
  utm_source: z.string().max(255).optional().or(z.literal("")),
  utm_medium: z.string().max(255).optional().or(z.literal("")),
  utm_campaign: z.string().max(255).optional().or(z.literal("")),
  utm_term: z.string().max(255).optional().or(z.literal("")),
  utm_content: z.string().max(255).optional().or(z.literal("")),
});

export const submitGhlWebhookLead = createServerFn({ method: "POST" })
  .inputValidator((input: unknown) => payloadSchema.parse(input))
  .handler(async ({ data }) => {
    const url = process.env.GHL_WEBHOOK_URL;
    if (!url) {
      console.error("GHL_WEBHOOK_URL not configured");
      return { success: false as const, error: "Submission destination not configured" };
    }
    try {
      const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });
      if (!res.ok) {
        console.error(`GHL webhook forward failed: ${res.status} ${res.statusText}`);
        return { success: false as const, error: `Upstream error (${res.status})` };
      }
      return { success: true as const };
    } catch (err) {
      console.error("GHL webhook forward exception:", err);
      return { success: false as const, error: "Failed to send. Please try again." };
    }
  });
